import axios from 'axios';
import { Envelope } from '../interfaces/envelope';
import { Room } from '../interfaces/rooms';

async function getRooms(): Promise<Room[]> {
	try {
		const response = await axios.get<Envelope<Room[]>>(`lighting/rooms`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

async function getRoom(roomId: number): Promise<Room> {
	try {
		const response = await axios.get<Envelope<Room>>(`lighting/rooms/${roomId}`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

export const rooms = {
	getRooms,
	getRoom,
};
